// The model-tier tag — which frontier lane this project (or this account) runs on:
// Luna (the cheaper model, low intent by rule, no concierge) or Terra (the default),
// decided once from the client's browser-detected country. See lib/model-tier.ts.
//
// A TAG like WorkShapeTag beside it, not an alert: it says how the client IS served,
// not that somebody must act. One component across the surfaces that show it (the
// Explorer tables, the project page, the user page) so the label and tone never drift.
import { Badge, type BadgeTone } from "@recruiter/shared";

import { isModelTier, modelTierLabel, modelTierTitle } from "../lib/model-tier";

const TONE_BY_TIER: Record<string, BadgeTone> = {
  // The default lane stays quiet; the lane that changes what every agent runs on
  // gets the louder tone.
  terra: "neutral",
  luna: "info",
};

/** Renders nothing while the row carries no tier (older than migration 0195, or a
 *  payload that predates the field), so a caller can drop it in unconditionally. The
 *  country, when known, rides in parentheses: it is the WHY behind the tier. */
export function ModelTierTag({
  tier,
  country,
  size = "sm",
}: {
  tier: string | null | undefined;
  country?: string | null;
  size?: "sm" | "md";
}) {
  if (!isModelTier(tier)) return null;
  return (
    <Badge tone={TONE_BY_TIER[tier] ?? "neutral"} size={size} title={modelTierTitle(tier, country)}>
      {modelTierLabel(tier)}
      {country ? ` (${country})` : ""}
    </Badge>
  );
}
